/* eslint-disable */
<template>
	<section class="body">
		<header class="header">
			<div class="logo-container">
				<router-link to="/index" class="logo">
					<img :src="require(`@/assets/images/logo.2021.png`)" width="200" height="50" alt="logo" />
				</router-link>
				<div class="visible-xs toggle-sidebar-left" data-toggle-class="sidebar-left-opened" data-target="html" data-fire-event="sidebar-left-opened">
					<i class="fa fa-bars" aria-label="Toggle sidebar"></i>
				</div>
			</div>
			<!-- start: search & user box -->
			<div class="header-right" v-if="this.isLogin">
				<div class="signout-timer" v-if="this.isLogin != null">
					<p class="col-xs-12 form-inline" v-if="sessionData.accountType != 'ADM'">
						<select class="form-control" v-if="deptList.length > 0" v-model="deptCode" @change="changeDeptCode">
							<option value="">--請選擇--</option>
							<option v-for="(item, key) in deptList" :key="key" :value="item.unitId">{{item.unitStr}}</option>
						</select>
						<label class="form-inline" style="font-size:15px;">{{this.sessionData.accountTypeStr + ' - '+ this.sessionData.name}}</label>
					</p>
					<p class="col-xs-12 form-inline" v-else>
						學工號: <input id="" v-model="stuAccount" />
						<button type="button" @click="changeAccount()">切換</button>
					</p>
				</div>
				<span class="separator"></span>
				<div class="notifications">
					<button type="button" role="menuitem" tabindex="-1" class="btn-link" @click="logout">
						<i class="fa fa-power-off"></i> Logout
					</button>
				</div>
			</div>
			<div class="header-right" v-else>
				<span class="separator"></span>
				<div class="notifications">
					<button type="button" role="menuitem" tabindex="-1" class="btn-link" @click="showLoginPopupControl(true)">
						<i class="fa fa-power-off"></i> Login
					</button>
				</div>
			</div>
			<!-- end: search & user box -->
		</header>
		<div class="inner-wrapper">
			<aside id="sidebar-left" class="sidebar-left">
				<div class="sidebar-header">
					<div class="sidebar-title">選單列表</div>
					<div class="sidebar-toggle hidden-xs" data-toggle-class="sidebar-left-collapsed" data-target="html" data-fire-event="sidebar-left-toggle">
						<i class="fa fa-bars" aria-label="Toggle sidebar"></i>
					</div>
				</div>
				<div class="nano">
					<div class="nano-content">
						<nav id="menu" class="nav-main tab-navigation" role="navigation">
							<ul :class="'nav nav-main'" v-for="(item, index) in menuList.root" :key="index" >
								<li class="nav-parent">
									<a href="javascript:;">
										<i class="fa fa-fighter-jet" :style="{marginRight:'0.3rem'}"></i>
										{{item.title}}
									</a>
									<navMenu :cssClass="'nav nav-children'" :listKey="item.id" :menuList="menuList" />
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</aside>
			<router-view></router-view>
		</div>
		<footer></footer>
		<loginPopup v-if="isShowLogin" />
		<stayStatePopup v-if="isShowStayStatePopup"/>
		<stayBillingPopup v-if="isShowStayBillingPopup" />
		<assistStatePopup v-if="isShowAssistStatePopup" :type="assistStatePopupType"/>
	</section>
</template>
<script>
import loginPopup from './components/popup/login';
import stayStatePopup from './components/popup/stayState';
import stayBillingPopup from './components/popup/stayBillingInvoice';
import assistStatePopup from './components/popup/assistState';
import navMenu from './menu/navMenu';
export default {
	components:{
		loginPopup,
		stayStatePopup,
		stayBillingPopup,
		assistStatePopup,
		navMenu
	},
	data() {
		return {
			accountType:"",
			accountTypeStr: "",
			name: "",
			collapseClass:"",
			isShowLogin:false,
			isShowStayStatePopup:false,
			isShowStayBillingPopup:false,
			isShowAssistStatePopup:false,
			menuList:{},
			deptList:[],
			deptCode:"",
			stuAccount:"",
			assistStatePopupType: ""
		};
	},
	methods: {
		loginComplete(accountData){
			if("deptList" in accountData){
				this.deptList = accountData.deptList;
			}
			const api = "/api/Index/loginComplete";
			this.$axios.post(api, JSON.stringify(accountData)).then(resp =>{
				let resultObj = resp.data.data;
				this.loginInit(resultObj);
			});
		},
		loginInit(data) {
			if(data){
				this.setStore( "oitToken", data.token );
				this.setStore( "session.data", data.sessionData );
				this.deptCode = data.sessionData.deptCode;
				this.removeStore("menu");
				if(data.menu){
					this.setStore( "menu", data.menu);
				}
			}else{
				this.clearStore();
			}
			this.menuList = this.buildMenu();
			this.showLoginPopupControl(false);
			window.location.href = "/";
		},
		logout() {
			this.clearStore();
			this.menuList = this.buildMenu();
			this.deptList= [];
			window.location.href = "/";
		},
		showLoginPopupControl(control){
			this.isShowLogin = control;
		},
		showStayStateControl(control){
			this.isShowStayStatePopup = control;
		},
		showStayBillingControl(control){
			this.isShowStayBillingPopup = control;
		},
		showAssistStateControl(control, type){
			this.assistStatePopupType = type;
			this.isShowAssistStatePopup = control;
		},
		changeAccount(){
			let _this = this;
			const api = "/api/Index/changeAccount/"+this.stuAccount;
			this.$axios.post(api, JSON.stringify({})).then(resp => {
				if (resp.data.status == "success"){
					_this.$parent.clearStore();
					_this.accountData = resp.data.data.sessionData;
					_this.loginComplete(_this.accountData);
				}else{
					bootbox.alert(resp.data.msg);
				}
			});
		},
		changeDeptCode(){
			if(this.deptCode){
				let sd = this.sessionData;
				sd.deptCode = this.deptCode
				sd.deptList = this.deptList;
				this.loginComplete(sd);
			}

		},

		expand( $li ) {
			let _this = this;
			$li.children( 'ul.nav-children' ).slideDown( 'fast', function() {
				$li.addClass( 'nav-expanded' );
				$(this).css( 'display', '' );
				_this.ensureVisible( $li );
			});
		},
		collapse( $li ) {
			$li.children('ul.nav-children' ).slideUp( 'fast', function() {
				$(this).css( 'display', '' );
				$li.removeClass( 'nav-expanded' );
			});
		},
		ensureVisible( $li ) {
			var scroller = $li.offsetParent();
			if ( !scroller.get(0) ) {
				return false;
			}

			var top = $li.position().top;
			if ( top < 0 ) {
				scroller.animate({
					scrollTop: scroller.scrollTop() + top
				}, 'fast');
			}
		},
		buildSidebarNav( anchor, prev, next, ev ) {
			let _this = this;
			if ( anchor.prop('href') ) {
				var arrowWidth = parseInt(window.getComputedStyle(anchor.get(0), ':after').width, 10) || 0;
				if (ev.offsetX > anchor.get(0).offsetWidth - arrowWidth) {
					ev.preventDefault();
				}
			}

			if ( prev.get( 0 ) !== next.get( 0 ) ) {
				_this.collapse( prev );
				_this.expand( next );
			} else {
				_this.collapse( prev );
			}
		},
	},
	mounted() {
		const portalData = this.$route.query;
		if(portalData && !this.jsonIsEmpty(portalData)){
			if("USID" in portalData && "SEID" in portalData){
				let _this = this;
				const api = "/api/Index/loginLink?usid="+portalData.USID+"&seid="+portalData.SEID;
				this.$axios.post(api).then(resp => {
					_this.$parent.clearStore();
					if (resp.data.status == "success"){
						_this.accountData = resp.data.data.sessionData;
						_this.loginComplete(_this.accountData);
					}else{
						bootbox.alert(resp.data.msg, function(){
							_this.loginInit();
						});
					}
				});
			}
		}else{
			this.appInit().then(() => {
				this.menuList = this.buildMenu();
				if(this.sessionData.accountType == "TCH"){
					this.deptCode = this.sessionData.deptCode;
					const api = "/api/Index/unitList/"+this.sessionData.account;
					this.$axios.post(api).then(resp =>{
						this.deptList = resp.data.data;
					});
				}
			})

		}
	},
	updated(){
		let _this = this;
		var $items = $( '.nav-main li.nav-parent' );
		$items.find('> a').unbind();
		$items.find('> a').on('click', function( ev ) {

			var $html   = $('html'),
				$window = $(window),
				$anchor = $( this ),
				$prev   = $anchor.closest('ul.nav').find('> li.nav-expanded' ),
				$next   = $anchor.closest('li'),
				$ev     = ev;
			if( !$html.hasClass('sidebar-left-big-icons') ) {
				_this.buildSidebarNav( $anchor, $prev, $next, $ev );
			} else if( $html.hasClass('sidebar-left-big-icons') && $window.width() < 768 ) {
				_this.buildSidebarNav( $anchor, $prev, $next, $ev );
			}

		});
	}
};
</script>
<style>
@font-face {
	font-family:"細明體";
	src:url(http://portal.oit.edu.tw/fonts/eudc.ttf) format('truetype');
}

@media (max-width: 768px){
	.col-xs-offset-util-3{
		margin-left:25% !important;
	}
}

.column-required::before {
	content: "*";
	color: red;
}

.selbox {
	margin: 0 10% 0 0 !important;
	width: 90%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

@media (min-width: 992px) {
	.col-md-u {
		width: 13%;
	}
	.col-md-offset-util-3{
		margin-left:25% !important;
	}
}
</style>
